import { render } from "./PreferencesDialog.vue?vue&type=template&id=e9731dc8&ts=true"
import script from "./PreferencesDialog.vue?vue&type=script&lang=ts"
export * from "./PreferencesDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__